"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionsCommonSchema = exports.optionsDriversSchema = void 0;
exports.isVideoElement = isVideoElement;
exports.getVideoElement = getVideoElement;
exports.startPlayingVideoElement = startPlayingVideoElement;
exports.stopPlayingVideoElement = stopPlayingVideoElement;
exports.isVolumeChanged = isVolumeChanged;
exports.unmuteVideoElement = unmuteVideoElement;
exports.changeVolumeVideoElement = changeVolumeVideoElement;
exports.muteVideoElement = muteVideoElement;
exports.updateSource = updateSource;
const state_flow_1 = require("@video/state-flow");
const zod_1 = require("zod");
function isVideoElement(el) {
    return typeof el === "object" && String(el) === "[object HTMLVideoElement]";
}
function getVideoElement(el) {
    if (isVideoElement(el)) {
        return el;
    }
    throw new Error("host is not a video element");
}
function startPlayingVideoElement({ host }) {
    const el = getVideoElement(host.element);
    return state_flow_1.Result.transition(el.play().then(() => state_flow_1.Result.ok()));
}
function stopPlayingVideoElement({ host }) {
    const el = getVideoElement(host.element);
    el.pause();
    return state_flow_1.Result.ok();
}
function isVolumeChanged(volume1, volume2) {
    return Math.abs(volume1 - volume2) > 0.0001;
}
function unmuteVideoElement({ host, audio }) {
    const el = getVideoElement(host.element);
    if (!el.muted) {
        return state_flow_1.Result.ignore();
    }
    el.muted = false;
    el.volume = audio.volume;
    return state_flow_1.Result.ok();
}
function changeVolumeVideoElement({ host, audio }) {
    const el = getVideoElement(host.element);
    if (!isVolumeChanged(el.volume, audio.volume)) {
        return state_flow_1.Result.ignore();
    }
    el.volume = audio.volume;
    return state_flow_1.Result.ok();
}
function muteVideoElement({ host }) {
    const el = getVideoElement(host.element);
    if (el.muted) {
        return state_flow_1.Result.ignore();
    }
    el.muted = true;
    return state_flow_1.Result.ok();
}
function updateSrcObject(el, src) {
    if (el.srcObject === src) {
        return;
    }
    const playing = !el.paused;
    if (playing) {
        el.pause();
    }
    if (el.src != null && el.src !== "") {
        el.src = "";
    }
    el.srcObject = src;
    if (playing) {
        el.play();
    }
}
function updateSrcUrl(el, src) {
    if (el.src === src) {
        return;
    }
    const playing = !el.paused;
    if (playing) {
        el.pause();
    }
    if (el.srcObject != null) {
        el.srcObject = null;
    }
    el.src = src;
    if (playing) {
        el.play();
    }
}
function updateSource(el, src) {
    if (typeof src === "string") {
        updateSrcUrl(el, src);
    }
    else {
        updateSrcObject(el, src);
    }
}
function deprecated(desc) {
    return (val, ctx) => ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: `deprecated: ${desc}` });
}
exports.optionsDriversSchema = zod_1.z.enum(["webrtc", "hlsjs", "native-hls", "mp4ws", "flvhttp"]);
exports.optionsCommonSchema = zod_1.z.object({
    timeout: zod_1.z.number().min(1000).max(30000).default(10000).describe("timeout to start player"),
    // deprecated ones
    bitrate: zod_1.z.number().optional().superRefine(deprecated("use 'preferredLevel' from root options instead")),
    muted: zod_1.z.boolean().optional().superRefine(deprecated("use 'muted' from root options instead")),
    volume: zod_1.z.number().optional().superRefine(deprecated("use 'volume' from root options instead")),
    autoPlay: zod_1.z.boolean().optional().superRefine(deprecated("use 'autoPlay' from root options instead")),
    preset: zod_1.z.null().optional().superRefine(deprecated("use 'preferredLevel' from root options instead")),
});
//
// const optionsShortSchema = driversListSchema.transform((id) => optionsLongSchema.parse({ id }));
//
// export const optionsSchema = optionsShortSchema.or(optionsLongSchema);
//
// export type optionsSchemaInput = z.input<typeof optionsSchema>;
// export type optionsSchemaOutput = z.output<typeof optionsSchema>;
//# sourceMappingURL=common.js.map